module.exports = __webpack_public_path__ + "img/move.bc783797.png";